module.exports = __webpack_public_path__ + "static/media/product-data.0f9c3673.svg";